import React from "react"
import { motion } from "framer-motion"
import about from "../assets/about-image.jpg"

export const About: React.FC = () => {
	return (
		<section id='about' className='py-16 px-6 bg-white text-primary'>
			<motion.div
				initial={{ y: 50, opacity: 0 }}
				whileInView={{ y: 0, opacity: 1 }}
				viewport={{ once: true }}
				transition={{ duration: 0.5 }}>
				<h3 className='text-3xl font-bold text-center mb-8'>O nas</h3>
				<div className='flex flex-col md:flex-row items-center justify-center gap-8 max-w-5xl mx-auto'>
					{/* Image Section */}
					<div className='flex-shrink-0'>
						<img
							src={about}
							alt='About us graphic'
							className='w-72 h-72 object-cover rounded-lg shadow-lg'
						/>
					</div>
					{/* Text Section */}
					<div className='max-w-lg text-justify'>
						{" "}
						{/* Wyjustowanie tekstu */}
						<p>
							Nasze biuro rachunkowe to miejsce, w którym profesjonalizm łączy
							się z indywidualnym podejściem do każdego klienta. Rozumiemy, jak
							różnorodne mogą być potrzeby przedsiębiorców, dlatego oferujemy
							kompleksowe wsparcie księgowe, dostosowane do specyfiki każdej
							firmy, niezależnie od jej wielkości czy branży.
						</p>
						<p className='mt-4'>
							Naszym celem jest nie tylko obsługa księgowa, ale przede wszystkim
							wsparcie w podejmowaniu kluczowych decyzji biznesowych.
						</p>
						<p className='mt-4'>
							Wierzymy, że solidna i otwarta komunikacja jest kluczem do
							budowania trwałych relacji. Dlatego stawiamy na bieżący kontakt z
							naszymi klientami, co pozwala nam reagować szybko i skutecznie.
							Dzięki naszemu doświadczeniu i zaangażowaniu, zapewniamy
							przedsiębiorcom spokój ducha, umożliwiając im koncentrację na
							rozwijaniu własnego biznesu.
						</p>
					</div>
				</div>
			</motion.div>
		</section>
	)
}
